import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import loginSchema from './Login.schema';
import useLoginFormInitialValue from './useLoginFormInitialValue';
import useLoginSubmit from './useLoginSubmit';
import useLoginUrlContext from './useLoginUrlContext';
import { Title } from './Login.styles';
import AlertMessage from './AlertMessage';
import LoginForm from './LoginForm';
import LoginContextError from './LoginContextError';
import ServiceProviderWarningMessage from './ServiceProviderWarningMessage';
import FormWithProvider from '@/components/forms/form/Form';
import { Location } from '@/utils/windowsUtils';

const LoginSignInSection = () => {
  const { t } = useTranslation();
  const {
    handleSubmitLogin,
    clearErrors,
    noticeMessage,
    isDesktopServiceProviderUser,
    isSubmitting,
  } = useLoginSubmit();
  const { initialValue } = useLoginFormInitialValue();

  return (
    <FormWithProvider
      horizontal
      onSubmit={handleSubmitLogin}
      resolver={loginSchema()}
      defaultValues={initialValue}
    >
      <Row className="justify-content-center width-full">
        <Col sm={8} md={8} lg={7} xl={5}>
          <Title data-testid="login-title">{t('pageLogin.title')}</Title>
          <AlertMessage />
          <LoginForm
            clearErrors={clearErrors}
            isDesktopServiceProviderUser={isDesktopServiceProviderUser}
            isSubmitting={isSubmitting}
            noticeMessage={noticeMessage}
          />
          {isDesktopServiceProviderUser && <ServiceProviderWarningMessage />}
        </Col>
      </Row>
    </FormWithProvider>
  );
};

const Login = () => {
  const { isPkceValid, appContext, hasAppUrl } = useLoginUrlContext();

  useEffect(() => {
    // if the page is loaded in an iframe (possible redirection from a legacy jsp page), force rendering in the top window
    if (window.self !== window.top && window.top) {
      window.top.location.href = window.location.href;
    }
  }, []);

  useEffect(() => {
    if (!isPkceValid && hasAppUrl && appContext.appUrl) {
      Location.change(appContext.appUrl);
    }
  }, [isPkceValid, hasAppUrl, appContext.appUrl]);

  if (!isPkceValid) {
    if (hasAppUrl) {
      return (
        <Row
          className="justify-content-center width-full"
          data-testid="login-redirecting"
        />
      );
    }
    return <LoginContextError />;
  }

  return <LoginSignInSection />;
};

export default Login;
